import React from "react";
import { InformationCircleIcon } from "@heroicons/react/24/outline";

export default function MemberInformation({
    memberData,
    loadingSubs,
    loadingMemberInfo,
    memberInfoError,
}) {
    return (
        <div className="border border-gray-200 rounded-lg p-6 mb-6 shadow-sm bg-white">
            <h2 className="text-sm font-bold text-black mb-4">
                Member Information
            </h2>

            <div className="space-y-2 text-xs">
                <div className="grid grid-cols-12 gap-4">
                    <div className="col-span-4 font-medium text-black">Name</div>
                    <div className="col-span-8 text-gray-500">{memberData.name}</div>
                </div>

                <div className="grid grid-cols-12 gap-4">
                    <div className="col-span-4 font-medium text-black">
                        Phone Number
                    </div>
                    <div className="col-span-8 text-gray-500">{memberData.phone}</div>
                </div>

                <div className="grid grid-cols-12 gap-4">
                    <div className="col-span-4 font-medium text-black">Client ID</div>
                    <div className="col-span-8 text-gray-500">{memberData.clientId}</div>
                </div>

                <div className="grid grid-cols-12 gap-4">
                    <div className="col-span-4 font-medium text-black">Email Id</div>
                    <div className="col-span-8 text-gray-500">{memberData.email}</div>
                </div>

                <div className="grid grid-cols-12 gap-4">
                    <div className="col-span-4 font-medium text-black">
                        Subscription
                    </div>
                    <div className="col-span-8 text-gray-500 flex items-center gap-2">
                        {loadingSubs ? "Loading..." : memberData.plan}
                        <InformationCircleIcon className="h-4 w-4 text-gray-400" />
                    </div>
                </div>

                <div className="grid grid-cols-12 gap-4">
                    <div className="col-span-4 font-medium text-black">Credits</div>
                    <div className="col-span-8 text-green-500 font-medium">
                        {loadingMemberInfo ? "Loading..." : memberData.credits}
                    </div>
                </div>

                {memberInfoError && (
                    <div className="text-xs text-red-500">{memberInfoError}</div>
                )}

                <div className="grid grid-cols-12 gap-4">
                    <div className="col-span-4 font-medium text-black">
                        Billing Address
                    </div>
                    <div className="col-span-8 text-gray-500 leading-relaxed">
                        {memberData.address}
                    </div>
                </div>
            </div>
        </div>
    );
}
